import { AiOutlineTransaction } from "react-icons/ai";
import { FaDesktop } from "react-icons/fa6";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { IoSettingsOutline } from "react-icons/io5";
import {
  MdInventory2,
  MdOutlinePointOfSale,
  MdSell,
  MdVerifiedUser,
} from "react-icons/md";
import {
  ArrowLeftRight,
  PackageX,
  CreditCard,
  TrendingUp,
  Receipt,
  FileText,
  Package,
  AlertTriangle,
  RotateCcw,
  CheckCircle,
  RefreshCw,
  Truck,
  Users,
  Building2,
  Settings,
  Database,
  Calendar,
  DollarSign,
  ShoppingCart,
  BarChart3,
  FileSpreadsheet,
  ClipboardList,
  Activity,
  History,
  Send,
  Inbox,
  UserCheck,
  PackageCheck,
  PackagePlus,
  PackageMinus,
  Layers,
  ScanBarcode,
  LayoutDashboard,
  Store,
  ArrowRightLeft,
  FileBarChart,
  Shield,
  Boxes,
  Wallet,
  TrendingDown,
  PackageOpen,
  Filter,
  PackageSearch,
  Tags,
  Repeat,
  FileClock,
  UserCog,
  Briefcase,
  Building,
  PieChart,
  FileCheck,
  AlertCircle,
  CircleDollarSign,
  ListChecks,
  Eye,
  Stamp,
  Clock,
  Banknote,
  PackageMinus as Damage,
  FileOutput,
  UserPlus,
  ArchiveRestore,
  ShieldAlert,
  MessageSquare,
} from "lucide-react";

export const superadminRoutes = [
  {
    label: "Dashboard",
    path: "/super-admin/dashboard",
    icon: <LayoutDashboard />,
  },
  {
    label: "POS",
    path: "/dashboard",
    icon: <Store />,
    submenus: [
      {
        label: "Item Return",
        path: "/pos/return",
        icon: <RotateCcw size={16} />,
      },
      {
        label: "Damages/Internal Usage",
        path: "/inventory/damages",
        icon: <PackageX size={16} />,
      },
    ],
  },
  {
    label: "Transaction",
    path: "/transaction",
    icon: <ArrowRightLeft />,
    submenus: [
      {
        label: "Supplier Transaction",
        path: "/transaction/supplier",
        icon: <Truck size={16} />,
      },
      {
        label: "Expense Transaction",
        path: "/transaction/expense",
        icon: <Receipt size={16} />,
      },
    ],
  },
  {
    label: "Inventory",
    path: "/transaction",
    icon: <Boxes />,
    submenus: [
      {
        label: "Interbranch Transfer",
        path: "/inventory/interbranch",
        icon: <ArrowLeftRight size={16} />,
      },
      {
        label: "Inventory/Stock List",
        path: "/inventory/stock",
        icon: <ClipboardList size={16} />,
      },
      {
        label: "Stock Inventory",
        path: "/pos/damages-internal-usage",
        icon: <PackageSearch size={16} />,
        subitems: [
          {
            label: "Items Below Reorder",
            path: "/inventory/reorder/level",
            icon: <AlertTriangle size={14} />,
          },
          {
            label: "Restock Inventory",
            path: "/inventory/restock",
            icon: <PackagePlus size={14} />,
          },
          {
            label: "Branch Reconciliation",
            path: "/inventory/reconciliation",
            icon: <CheckCircle size={14} />,
          },
        ],
      },
      {
        label: "Supplier Invoice",
        path: "/inventory/invoice",
        icon: <FileText size={16} />,
      },
      {
        label: "Branch Inventory With Zero Stock",
        path: "/inventory/zero-stock",
        icon: <PackageMinus size={16} />,
      },
      {
        label: "Clear Branch Stock",
        path: "/inventory/zero-branch-stock",
        icon: <ShieldAlert size={16} />,
      },
      {
        label: "Batch Tracking",
        path: "/inventory/batch-tracking",
        icon: <ScanBarcode size={16} />,
      },
    ],
  },
  {
    label: "Authorization",
    path: "/transaction",
    icon: <Shield />,
    submenus: [
      {
        label: "Requisition Overview",
        path: "/inventory/requisition/overview",
        icon: <Eye size={16} />,
      },
      {
        label: "Authorize Requisition",
        path: "/authorize/requisition",
        icon: <CheckCircle size={16} />,
      },
      {
        label: "Authorize Interbranch",
        path: "/authorize/interbranch",
        icon: <Stamp size={16} />,
      },
    ],
  },
  {
    label: "Reports",
    path: "/transaction",
    icon: <FileBarChart />,
    submenus: [
      {
        label: "Cash Sales Report",
        path: "",
        icon: <Banknote size={16} />,
        subitems: [
          {
            label: "Dispenser Sales Report",
            path: "/report/cash/sales",
            icon: <BarChart3 size={14} />,
          },
          {
            label: "Sales By Branch",
            path: "/report/cash/branch",
            icon: <Building2 size={14} />,
          },
          {
            label: "Sales By Session",
            path: "/report/cash/session",
            icon: <Clock size={14} />,
          },
          {
            label: "Sales By Session(Details)",
            path: "/report/cash/session/details",
            icon: <FileCheck size={14} />,
          },
        ],
      },
      {
        label: "Credit Sales Report",
        path: "/pos/damages-internal-usage",
        icon: <CreditCard size={16} />,
        subitems: [
          {
            label: "Customer Credit By Branch",
            path: "/report/credit/outstanding",
            icon: <Building2 size={14} />,
          },
          {
            label: "Customer Credit By Staff",
            path: "/report/credit/cashier",
            icon: <UserCheck size={14} />,
          },
          {
            label: "Credit Repayment",
            path: "/report/credit/repayment",
            icon: <CircleDollarSign size={14} />,
          },
          {
            label: "Internal Usage Report",
            path: "/report/credit/internal",
            icon: <Activity size={14} />,
          },
        ],
      },
      {
        label: "Transaction Reports",
        path: "",
        icon: <ArrowRightLeft size={16} />,
        subitems: [
          {
            label: "Expenses Report",
            path: "/report/transaction/expense",
            icon: <Receipt size={14} />,
          },
          {
            label: "Interbranch Report",
            path: "/report/transaction/interbranch",
            icon: <ArrowLeftRight size={14} />,
          },
          {
            label: "Income Statement",
            path: "/report/transaction/income-statement",
            icon: <TrendingUp size={14} />,
          },
        ],
      },
      {
        label: "Purchases Reports",
        path: "",
        icon: <ShoppingCart size={16} />,
        subitems: [
          {
            label: "Supplier Invoice",
            path: "/inventory/invoice",
            icon: <FileText size={14} />,
          },
          {
            label: "Supplier Payment",
            path: "/report/purchases/supplier/payment",
            icon: <DollarSign size={14} />,
          },
        ],
      },
      {
        label: "Inventory Reports",
        path: "",
        icon: <Boxes size={16} />,
        subitems: [
          {
            label: "Damages Report",
            path: "/report/credit/internal",
            icon: <PackageX size={14} />,
          },
          {
            label: "Stock Report",
            path: "/report/inventory/stock",
            icon: <ClipboardList size={14} />,
          },
          {
            label: "Reconciliation Report",
            path: "/report/inventory/reconciliation",
            icon: <CheckCircle size={14} />,
          },
          {
            label: "Item History(Retail)",
            path: "/report/inventory/history/retail",
            icon: <History size={14} />,
          },
          {
            label: "Item History(Warehouse)",
            path: "/report/inventory/history/warehouse",
            icon: <History size={14} />,
          },
          {
            label: "Item History(Stores)",
            path: "/report/inventory/history/stores",
            icon: <History size={14} />,
          },
          {
            label: "Item Activity",
            path: "/report/inventory/activity",
            icon: <Activity size={14} />,
          },
          {
            label: "Inventory With Available Stock",
            path: "/inventory/stock/available",
            icon: <Package size={14} />,
          },
        ],
      },
      {
        label: "Requisition Reports",
        path: "",
        icon: <FileOutput size={16} />,
        subitems: [
          {
            label: "Request Report",
            path: "/report/inventory/request",
            icon: <Send size={14} />,
          },
          {
            label: "Warehouse Supply Report",
            path: "/report/inventory/supply",
            icon: <PackageCheck size={14} />,
          },
          {
            label: "Branch Receipt Report",
            path: "/report/inventory/receipt",
            icon: <Inbox size={14} />,
          },
        ],
      },
    ],
  },
  {
    label: "Administration",
    path: "/administration",
    icon: <Settings />,
    submenus: [
      {
        label: "Suppliers",
        path: "/administration/suppliers",
        icon: <Truck size={16} />,
      },
      {
        label: "Users",
        path: "/administration/users",
        icon: <Users size={16} />,
      },
      {
        label: "Staff Schedule",
        path: "/administration/staff-schedule",
        icon: <Calendar size={16} />,
      },
      {
        label: "Branches",
        path: "/administration/branches",
        icon: <Building2 size={16} />,
      },
      {
        label: "Company Settings",
        path: "/administration/company",
        icon: <Building size={16} />,
      },
      {
        label: "Company Inventory",
        path: "/administration/inventory/",
        icon: <Database size={16} />,
      },
      {
        label: "SMS Bundle Usage",
        path: "/administration/sms-bundle",
        icon: <MessageSquare size={16} />,
      },
    ],
  },
];

export const cashierRoutes = [
  {
    label: "Dashboard",
    path: "/dispenser/dashboard",
    icon: <LayoutDashboard />,
  },
  {
    label: "POS",
    path: "/dashboard",
    icon: <Store />,
    submenus: [
      {
        label: "Dispenser",
        path: "/pos/dispenser",
        icon: <ShoppingCart size={16} />,
      },
      {
        label: "Stock Requisition",
        path: "/inventory/requisition",
        icon: <FileOutput size={16} />,
      },
      {
        label: "Damages/Internal Usage",
        path: "/inventory/damages",
        icon: <PackageX size={16} />,
      },
    ],
  },
  {
    label: "Inventory",
    path: "/transaction",
    icon: <Boxes />,
    submenus: [
      {
        label: "Inventory Prices",
        path: "/inventory/price-list/",
        icon: <Tags size={16} />,
      },
      {
        label: "Interbranch Transfer",
        path: "/inventory/interbranch",
        icon: <ArrowLeftRight size={16} />,
      },
      {
        label: "Reorder Level",
        path: "/inventory/reorder",
        icon: <AlertTriangle size={16} />,
      },
      {
        label: "Inventory/Stock List",
        path: "/inventory/stock",
        icon: <ClipboardList size={16} />,
      },
      {
        label: "Stock Inventory",
        path: "/pos/damages-internal-usage",
        icon: <PackageSearch size={16} />,
        subitems: [
          {
            label: "Items Below Reorder",
            path: "/inventory/reorder/level",
            icon: <AlertTriangle size={14} />,
          },
        ],
      },
      {
        label: "Batch Tracking",
        path: "/cashier/inventory/batch-tracking",
        icon: <ScanBarcode size={16} />,
      },
    ],
  },
  {
    label: "Sales",
    icon: <TrendingUp />,
    submenus: [
      {
        label: "Sales List",
        path: "/sales/list",
        icon: <ListChecks size={16} />,
      },
      {
        label: "Sale Returns",
        path: "/sales/item-return",
        icon: <RotateCcw size={16} />,
      },
      {
        label: "Item Return Witness Verification",
        path: "/sales/witness-verification",
        icon: <UserCheck size={16} />,
      },
    ],
  },
];

export const adminRoutes = [
  {
    label: "Dashboard",
    path: "/admin/dashboard",
    icon: <LayoutDashboard />,
  },
  {
    label: "Inventory",
    path: "/transaction",
    icon: <Boxes />,
    submenus: [
      {
        label: "Inventory/Stock List",
        path: "/inventory/stock",
        icon: <ClipboardList size={16} />,
      },
      {
        label: "Stock Inventory",
        path: "/pos/damages-internal-usage",
        icon: <PackageSearch size={16} />,
        subitems: [
          {
            label: "Items Below Reorder",
            path: "/inventory/reorder/level",
            icon: <AlertTriangle size={14} />,
          },
          {
            label: "Restock Inventory",
            path: "/inventory/restock",
            icon: <PackagePlus size={14} />,
          },
          {
            label: "Branch Reconciliation",
            path: "/inventory/reconciliation",
            icon: <CheckCircle size={14} />,
          },
          {
            label: "Reset/Zero Branch Inventory",
            path: "/inventory/reset",
            icon: <ArchiveRestore size={14} />,
          },
        ],
      },
      {
        label: "Supplier Invoice",
        path: "/inventory/invoice",
        icon: <FileText size={16} />,
      },
      {
        label: "Batch Tracking",
        path: "/inventory/batch-tracking",
        icon: <ScanBarcode size={16} />,
      },
    ],
  },
  {
    label: "Transaction",
    path: "/transaction",
    icon: <ArrowRightLeft />,
    submenus: [
      {
        label: "Expense Transaction",
        path: "/transaction/expense",
        icon: <Receipt size={16} />,
      },
    ],
  },
  {
    label: "Authorization",
    path: "/transaction",
    icon: <Shield />,
    submenus: [
      {
        label: "Authorize Interbranch",
        path: "/authorize/interbranch",
        icon: <Stamp size={16} />,
      },
    ],
  },
  {
    label: "Administration",
    path: "/administration",
    icon: <Settings />,
    submenus: [
      {
        label: "Suppliers",
        path: "/administration/suppliers",
        icon: <Truck size={16} />,
      },
      {
        label: "Users",
        path: "/administration/users",
        icon: <Users size={16} />,
      },
      {
        label: "Staff Schedule",
        path: "/administration/staff-schedule",
        icon: <Calendar size={16} />,
      },
      {
        label: "Branches",
        path: "/administration/branches",
        icon: <Building2 size={16} />,
      },
      {
        label: "Company Settings",
        path: "/administration/company",
        icon: <Building size={16} />,
      },
      {
        label: "Company Inventory",
        path: "/administration/inventory/",
        icon: <Database size={16} />,
      },
    ],
  },
];

export const itAuditorRoutes = [
  {
    label: "Dashboard",
    path: "/auditor/dashboard",
    icon: <LayoutDashboard />,
  },
  {
    label: "Reports",
    path: "/transaction",
    icon: <FileBarChart />,
    submenus: [
      {
        label: "Cash Sales Report",
        path: "",
        icon: <Banknote size={16} />,   
        subitems: [
          {
            label: "Dispenser Sales Report",
            path: "/report/cash/sales",
            icon: <BarChart3 size={14} />,
          },
          {
            label: "Sales By Branch",
            path: "/report/cash/branch",
            icon: <Building2 size={14} />,
          },
          {
            label: "Sales By Session",
            path: "/report/cash/session",
            icon: <Clock size={14} />,
          },
          {
            label: "Sales By Session(Details)",
            path: "/report/cash/session/details",
            icon: <FileCheck size={14} />,
          },
        ],
      },
      {
        label: "Credit Sales Report",
        path: "/pos/damages-internal-usage",
        icon: <CreditCard size={16} />,
        subitems: [
          {
            label: "Customer Credit By Branch",
            path: "/report/credit/outstanding",
            icon: <Building2 size={14} />,
          },
          {
            label: "Customer Credit By Staff",
            path: "/report/credit/cashier",
            icon: <UserCheck size={14} />,
          },
          {
            label: "Credit Repayment",
            path: "/report/credit/repayment",
            icon: <CircleDollarSign size={14} />,
          },
          {
            label: "Internal Usage Report",
            path: "/report/credit/internal",
            icon: <Activity size={14} />,
          },
        ],
      },
      {
        label: "Transaction Reports",
        path: "",
        icon: <ArrowRightLeft size={16} />,
        subitems: [
          {
            label: "Expenses Report",
            path: "/report/transaction/expense",
            icon: <Receipt size={14} />,
          },
          {
            label: "Interbranch Report",
            path: "/report/transaction/interbranch",
            icon: <ArrowLeftRight size={14} />,
          },
          {
            label: "Income Statement",
            path: "/report/transaction/income-statement",
            icon: <TrendingUp size={14} />,
          },
        ],
      },
      {
        label: "Purchases Reports",
        path: "",
        icon: <ShoppingCart size={16} />,
        subitems: [
          {
            label: "Supplier Invoice",
            path: "/inventory/invoice",
            icon: <FileText size={14} />,
          },
          {
            label: "Supplier Payment",
            path: "/report/purchases/supplier/payment",
            icon: <DollarSign size={14} />,
          },
        ],
      },
      {
        label: "Inventory Reports",
        path: "",
        icon: <Boxes size={16} />,
        subitems: [
          {
            label: "Damages Report",
            path: "/report/credit/internal",
            icon: <PackageX size={14} />,
          },
          {
            label: "Stock Report",
            path: "/report/inventory/stock",
            icon: <ClipboardList size={14} />,
          },
          {
            label: "Reconciliation Report",
            path: "/report/inventory/reconciliation",
            icon: <CheckCircle size={14} />,
          },
          {
            label: "Item History(Retail)",
            path: "/report/inventory/history/retail",
            icon: <History size={14} />,
          },
          {
            label: "Item History(Warehouse)",
            path: "/report/inventory/history/warehouse",
            icon: <History size={14} />,
          },
          {
            label: "Item History(Stores)",
            path: "/report/inventory/history/stores",
            icon: <History size={14} />,
          },
          {
            label: "Item Activity",
            path: "/report/inventory/activity",
            icon: <Activity size={14} />,
          },
        ],
      },
      {
        label: "Requisition Reports",
        path: "",
        icon: <FileOutput size={16} />,
        subitems: [
          {
            label: "Request Report",
            path: "/report/inventory/request",
            icon: <Send size={14} />,
          },
          {
            label: "Warehouse Supply Report",
            path: "/report/inventory/supply",
            icon: <PackageCheck size={14} />,
          },
          {
            label: "Branch Receipt Report",
            path: "/report/inventory/receipt",
            icon: <Inbox size={14} />,
          },
        ],
      },
    ],
  },
];

export const warehouseManagerRoutes = [
  {
    label: "Dashboard",
    path: "/warehouse-manager/dashboard",
    icon: <LayoutDashboard />,
  },
  {
    label: "BIE",
    path: "/",
    icon: <Store />,
    submenus: [
      {
        label: "Damages/Internal Usage",
        path: "/inventory/damages",
        icon: <PackageX size={16} />,
      },
    ],
  },
  {
    label: "Inventory",
    path: "/inventory",
    icon: <Boxes />,
    submenus: [
      {
        label: "Reorder Level",
        path: "/inventory/reorder",
        icon: <AlertTriangle size={16} />,
      },
      {
        label: "Inventory/Stock List",
        path: "/inventory/stock",
        icon: <ClipboardList size={16} />,
      },
      {
        label: "Batch Tracking",
        path: "/inventory/batch-tracking",
        icon: <ScanBarcode size={16} />,
      },
      {
        label: "Stores Inventory Requisition",
        path: "/warehouse-manager/inventory/requisition",
        icon: <FileOutput size={16} />,
      },
    ],
  },
  {
    label: "Authorization",
    path: "/transaction",
    icon: <Shield />,
    submenus: [
      {
        label: "Requisition Overview",
        path: "/inventory/requisition/overview",
        icon: <Eye size={16} />,
      },
      {
        label: "Authorize Requisition",
        path: "/authorize/requisition",
        icon: <CheckCircle size={16} />,
      },
      {
        label: "Authorize Interbranch",
        path: "/authorize/interbranch",
        icon: <Stamp size={16} />,
      },
    ],
  },
  {
    label: "Reports",
    path: "/transaction",
    icon: <FileBarChart />,
    submenus: [
      {
        label: "Cash Sales Report",
        path: "",
        icon: <Banknote size={16} />,
        subitems: [
          {
            label: "Dispenser Sales Report",
            path: "/report/cash/sales",
            icon: <BarChart3 size={14} />,
          },
          {
            label: "Sales By Branch",
            path: "/report/cash/branch",
            icon: <Building2 size={14} />,
          },
          {
            label: "Sales By Session",
            path: "/report/cash/session",
            icon: <Clock size={14} />,
          },
          {
            label: "Sales By Session(Details)",
            path: "/report/cash/session/details",
            icon: <FileCheck size={14} />,
          },
        ],
      },
      {
        label: "Inventory Reports",
        path: "",
        icon: <Boxes size={16} />,
        subitems: [
          {
            label: "Damages Report",
            path: "/report/credit/internal",
            icon: <PackageX size={14} />,
          },
          {
            label: "Stock Report",
            path: "/report/inventory/stock",
            icon: <ClipboardList size={14} />,
          },
          {
            label: "Reconciliation Report",
            path: "/report/inventory/reconciliation",
            icon: <CheckCircle size={14} />,
          },
          {
            label: "Item History(Retail)",
            path: "/report/inventory/history/retail",
            icon: <History size={14} />,
          },
          {
            label: "Item History(Warehouse)",
            path: "/report/inventory/history/warehouse",
            icon: <History size={14} />,
          },
        ],
      },
      {
        label: "Requisition Reports",
        path: "",
        icon: <FileOutput size={16} />,
        subitems: [
          {
            label: "Request Report",
            path: "/report/inventory/request",
            icon: <Send size={14} />,
          },
          {
            label: "Warehouse Supply Report",
            path: "/report/inventory/supply",
            icon: <PackageCheck size={14} />,
          },
          {
            label: "Branch Receipt Report",
            path: "/report/inventory/receipt",
            icon: <Inbox size={14} />,
          },
        ],
      },
    ],
  },
];

export const branchManagerRoutes = [
  {
    label: "Dashboard",
    path: "/branch-manager/dashboard",
    icon: <LayoutDashboard />,
  },
  {
    label: "POS",
    path: "/dashboard",
    icon: <Store />,
    submenus: [
      {
        label: "Dispenser",
        path: "/pos/dispenser",
        icon: <ShoppingCart size={16} />,
      },
      {
        label: "Stock Requisition",
        path: "/inventory/requisition",
        icon: <FileOutput size={16} />,
      },
      {
        label: "Sale Return List",
        path: "/pos/return/branch",
        icon: <RotateCcw size={16} />,
      },
      {
        label: "Damages/Internal Usage",
        path: "/inventory/damages",
        icon: <PackageX size={16} />,
      },
    ],
  },
  {
    label: "Inventory",
    path: "/transaction",
    icon: <Boxes />,
    submenus: [
      {
        label: "Inventory Prices",
        path: "/inventory/price-list/",
        icon: <Tags size={16} />,
      },
      {
        label: "Interbranch Transfer",
        path: "/inventory/interbranch",
        icon: <ArrowLeftRight size={16} />,
      },
      {
        label: "Reorder Level",
        path: "/inventory/reorder",
        icon: <AlertTriangle size={16} />,
      },
      {
        label: "Inventory/Stock List",
        path: "/inventory/stock",
        icon: <ClipboardList size={16} />,
      },
      {
        label: "Stock Inventory",
        path: "/pos/damages-internal-usage",
        icon: <PackageSearch size={16} />,
        subitems: [
          {
            label: "Items Below Reorder",
            path: "/inventory/reorder/level",
            icon: <AlertTriangle size={14} />,
          },
        ],
      },
      {
        label: "Zero Stock Drugs",
        path: "/inventory/zero-stock",
        icon: <PackageMinus size={16} />,
      },
      {
        label: "Batch Tracking",
        path: "/inventory/batch-tracking",
        icon: <ScanBarcode size={16} />,
      },
    ],
  },
  {
    label: "Sales",
    icon: <TrendingUp />,
    submenus: [
      {
        label: "Sales List",
        path: "/sales/list",
        icon: <ListChecks size={16} />,
      },
      {
        label: "Sale Returns",
        path: "/sales/item-return",
        icon: <RotateCcw size={16} />,
      },
      {
        label: "Item Return Witness Verification",
        path: "/sales/witness-verification",
        icon: <UserCheck size={16} />,
      },
    ],
  },
];


export const storeManagerRoutes = [
  {
    label: "Dashboard",
    path: "/store-manager/dashboard",
    icon: <FaDesktop />,
  },
  {
    label: "Inventory",
    path: "/transaction",
    icon: <MdInventory2 />,
    submenus: [
      {
        label: "Damages/Internal Usage",
        path: "/inventory/damages",
      },
      {
        label: "Reorder Level",
        path: "/inventory/reorder",
      },
      {
        label: "Supplier Invoice",
        path: "/inventory/invoice",
      },
      {
        label: "Inventory/Stock List",
        path: "/inventory/stock",
      },
      {
        label: "Zero Stock Drugs",
        path: "/inventory/zero-stock",
      },
      {
        label: "Batch Tracking",
        path: "/inventory/batch-tracking",
      },
    ],
  },
  {
    label: "Stock Requisition",
    path: "/transaction",
    icon: <MdInventory2 />,
    submenus: [
      {
        label: "Pending Requisitions",
        path: "/store-manager/requisition/pending",
      },
      {
        label: "Supplied Requisitions",
        path: "/store-manager/requisition/supplied",
      },
    ],
  },
  {
    label: "Administration",
    path: "/administration",
    icon: <IoSettingsOutline />,
    submenus: [
      {
        label: "Company Inventory",
        path: "/administration/inventory/",
      },
    ],
  },
];
